
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import { addVisitHistory } from '@/api/globalSearch'

@Component<GlobalSearch>({
    components: { Modal },
})
export default class GlobalSearch extends Vue {
    public showing = false
    public searching = false
    public keyword = ''
    public results: object = {}
    // for using arrow, which is currently selected
    public selected = -1
    public delayTimer // delay search on typing

    @Prop(Function) public search!: (search: string) => object

    public mounted() {
        this.bindKeyboardEvent()
    }

    @Watch('showing')
    public onShowingChanged() {
        // do a initial search when modal opens up
        if (this.showing && !this.keyword) {
            this.doSearch()
        }

        if (this.showing) {
            setTimeout(() => (this.$refs.input as HTMLElement).focus(), 10)
        }
    }

    @Watch('keyword')
    public onKeywordChanged() {
        clearTimeout(this.delayTimer)
        this.delayTimer = setTimeout(() => {
            this.doSearch()
        }, 300)
    }

    public bindKeyboardEvent() {
        document.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.metaKey && event.key === 'k') {
                event.preventDefault()
                this.showing = !this.showing
            } else if (this.showing) {
                // event.preventDefault()
                if (event.key === 'ArrowUp') {
                    this.selected = Math.max(0, this.selected - 1)
                } else if (event.key === 'ArrowDown') {
                    this.selected = Math.min(
                        this.resultsFlat.length - 1,
                        this.selected + 1
                    )
                } else if (event.key === 'Enter' && this.selectedItem) {
                    this.onClickItem(event, this.selectedItem)
                }
            }
        })
    }

    public get resultsFlat() {
        let results = []
        for (const groupName of Object.keys(this.results)) {
            results = results.concat(this.results[groupName])
        }
        return results
    }

    public get selectedItem() {
        if (this.selected < 0) {
            return null
        }
        return this.resultsFlat[this.selected]
    }

    public async doSearch() {
        this.searching = true
        this.results = await this.search(this.keyword)
        this.searching = false
    }

    public onClickItem(e, item) {
        const newTab = e.metaKey
        // put click to history
        addVisitHistory(JSON.stringify(item))
        if (newTab) {
            window.open(item.href, '_blank')
        } else {
            location.href = item.href
        }
    }
}
